import { createSelector } from '@ngrx/store';

import { selectJobDepositPosition } from '../../job/job-deposit.selectors';
import { timelineBookEventFeature } from '../../job/job-overview/overview-timeline/timeline-book-event/timeline-book-event.feature';
import { selectJob } from '../../job/job-tool.reducer';

export const selectDepositOutstandingToBookMinor = createSelector(
    selectJob,
    timelineBookEventFeature.selectBookEventDialog,
    selectJobDepositPosition,
    (job, { eventId, restrictionsDisabled }, { outstandingToBookMinor }) => {

        if (restrictionsDisabled) { return 0; }

        if (!job) { return 0; }

        const event = job.events?.find((e) => e.id === eventId);

        if (!event) { return 0; }

        if (event.subTotal <= 0) { return 0; }

        return outstandingToBookMinor;
    },
);
